module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="gererabsencesouhait-deleguer-popup">\r\n  <div class="gererabsencesouhait-deleguer-labels">\r\n    <label class="gererabsencesouhait-deleguer-label ui-phx-ihm-texte-application gererabsencesouhait-deleguer-title cw-texteNormal">'+
((__t=(i18n.t("message:GT_2002")))==null?'':__t)+
'</label>\r\n    <br/>\r\n    <label class="gererabsencesouhait-deleguer-label ui-phx-ihm-texte-application-important cw-titreBloc">'+
((__t=(i18n.t("messages:GT_2003")))==null?'':__t)+
'</label>\r\n    <br/>\r\n    <label class="gererabsencesouhait-deleguer-label ui-phx-ihm-texte-application cw-texteNormal">'+
((__t=(i18n.t("messages:GT_2016")))==null?'':__t)+
'</label>\r\n  </div>\r\n\r\n  <div class="d-flex" style="margin-top: 24px">\r\n    <button type="button" class="btnDeleguer btn btn-primary btn-withIcon bt-col-blue" style="margin-right: 24px" value="btnDeleguer">'+
((__t=(i18n.t("common:gererabsencesouhait.btnDeleguer")))==null?'':__t)+
''+
((__t=(UTILS.getSVGIcon('valider','',16)))==null?'':__t)+
'</button>\r\n    <button type="button" class="btnAnnuler btn btn-secondary btn-withIcon" value="btnAnnuler">'+
((__t=(i18n.t("common:gererabsencesouhait.btnAnnuler")))==null?'':__t)+
''+
((__t=(UTILS.getSVGIcon('croix','',16)))==null?'':__t)+
'</button>\r\n  </div>\r\n</div>\r\n';
}
return __p;
};
